import type { ReactNode } from "react";
import React from "react";

import { useRuntimeErrorTracker } from "../hooks/useErrorTracker";
import RuntimeErrorBoundary from "./RuntimeErrorBoundary";

export interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
  name?: string;
  namespace?: string;
}

export const ErrorBoundary = ({
  children,
  fallback,
  name,
  namespace,
}: ErrorBoundaryProps) => {
  const trackRuntimeError = useRuntimeErrorTracker(namespace);

  return (
    <RuntimeErrorBoundary
      blockableFlow={false}
      fallback={fallback}
      name={name}
      namespace={namespace}
      trackRuntimeError={trackRuntimeError}
    >
      {children}
    </RuntimeErrorBoundary>
  );
};

export default ErrorBoundary;
